import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { InconsistenciesSummary } from './get-inconsistencies-summary.type';
import { useGlobalStore } from '@old/global-store/use-store';
import { transformIntoQueryParamString } from '@old/utils/service';

export async function getInconsistenciesSummary() {
  const { organizationId } = useGlobalStore.getState();
  const rawQuery = {
    organizationId: organizationId,
  };
  const query = transformIntoQueryParamString(rawQuery);
  const { response, data } = await BACKEND.get<InconsistenciesSummary>(ENDPOINT.INCONSISTENCIES_SUMMARY, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
